import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/pages/auth/auth.context";

export function useModifyPaymentCheck(checkId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: {
      action?: "UPDATE" | "VOID" | "REISSUE" | "MARK_PAID";
      amount?: string;
      notes?: string;
      paymentReference?: string;
      voidReason?: string;
    }) => {
      const { data } = await axiosInstance.put(
        `/payment-checks/${checkId}`,
        payload,
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["checkBatch"] });
      queryClient.invalidateQueries({ queryKey: ["checkBatchStatistics"] });
    },
  });
}
